import axios from "axios";
import { SEARCH } from "../constants/ActionTypes";

export function searchProduct(producto) {
  console.log(producto, "NOMBRE aca");
  return async (dispatch) => {
    try {
      const encontrados = await axios.post(
        "http://localhost:3001/testeando",
        producto
      );

      dispatch({ type: SEARCH, payload: encontrados.data });
    } catch (error) {
      console.log(error);
    }
  };
}
